import {
  AspectRatio,
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  IconButton,
  Image,
  LinkOverlay,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  SimpleGrid,
  Stack,
  Text,
  VStack,
  createIcon,
  useColorMode,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import React, { Fragment } from "react";
import {
  calendarImageUrl,
  chatImageUrl,
  privacyImageUrl,
  seoThumbnailUrl,
  videoThumbnailUrl,
} from "../Components/imagesLink";

import { ArrowForwardIcon } from "@chakra-ui/icons";
import { Seo } from "../Components/Seo";

const PlayIcon = createIcon({
  displayName: "PlayIcon",
  viewBox: "0 0 58 58",
  d: "M28.9999 0.562988C13.3196 0.562988 0.562378 13.3202 0.562378 29.0005C0.562378 44.6808 13.3196 57.438 28.9999 57.438C44.6801 57.438 57.4374 44.6808 57.4374 29.0005C57.4374 13.3202 44.6801 0.562988 28.9999 0.562988ZM39.2223 30.272L23.5749 39.7247C23.3506 39.8591 23.0946 39.9314 22.8332 39.9342C22.5717 39.9369 22.3142 39.8701 22.0871 39.7406C21.86 39.611 21.6715 39.4234 21.5408 39.1969C21.4102 38.9705 21.3421 38.7133 21.3436 38.4519V19.5491C21.3421 19.2877 21.4102 19.0305 21.5408 18.8041C21.6715 18.5776 21.86 18.3899 22.0871 18.2604C22.3142 18.1308 22.5717 18.064 22.8332 18.0668C23.0946 18.0696 23.3506 18.1419 23.5749 18.2763L39.2223 27.729C39.4404 27.8619 39.6207 28.0486 39.7458 28.2713C39.8709 28.494 39.9366 28.7451 39.9366 29.0005C39.9366 29.2559 39.8709 29.507 39.7458 29.7297C39.6207 29.9523 39.4404 30.1391 39.2223 30.272Z",
});


export const Blob = (props) => {
  return (
    <Icon
      width={"100%"}
      viewBox="0 0 578 440"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M239.184 439.443c-55.13-5.419-110.241-21.365-151.074-58.767C42.307 338.722-7.478 282.729.938 221.217c8.433-61.644 78.896-91.048 126.871-130.712 34.337-28.388 70.198-51.348 112.004-66.78C282.34 8.024 325.382-3.369 370.518.904c54.019 5.115 112.774 10.886 150.881 49.482 39.916 40.427 49.421 100.753 53.385 157.402 4.13 59.015 11.255 128.44-30.444 170.44-41.383 41.683-111.6 19.106-169.213 30.663-46.68 9.364-88.56 35.21-135.943 30.551z"
        fill="currentColor"
      />
    </Icon>
  );
};

const Home = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {colorMode} = useColorMode();
  const Feature = ({ title, text, imageUrl, altDesc }) => {
    return (
      <Stack>
        <Flex justifyContent={"center"}>
          <Image
            width={"14rem"}
            src={imageUrl}
            className={"featureImg"}
            alt={altDesc}
          ></Image>
        </Flex>
        <Text fontWeight={600}>{title}</Text>
        <Text align={"justify"} color={"black.600"}>
          {text}
        </Text>
      </Stack>
    );
  };

  return (
    <div>
      {/* Main Content part */}
      <SimpleGrid columns={1} spacing={[10, 8, 5]} p={5}>
        <Seo
          title="WpCalendar | Whatsapp chat to calendar events!"
          description="Effortlessly convert WhatsApp chat events to calendar events with our privacy-conscious tool. Keep track of important dates without compromising your data privacy."
          type="website"
          name="Soham_UltraHopeful"
          url="https://wpcalendar.vercel.app"
          imageUrl={seoThumbnailUrl}
        />
        <Stack
          maxW={"7xl"}
          align={"center"}
          margin={"0 auto"}
          spacing={{ base: 8, md: 10 }}
          py={{ base: 20, md: 20 }}
          direction={{ base: "column", md: "row" }}
        >
          <Stack flex={1} spacing={{ base: 5, md: 10 }}>
            <Heading
              lineHeight={1.1}
              fontWeight={600}
              fontSize={{ base: "3xl", sm: "4xl", lg: "6xl" }}
            >
              <Text
                as={"span"}
                position={"relative"}
                _after={{
                  content: "''",
                  width: "full",
                  height: "30%",
                  position: "absolute",
                  bottom: 1,
                  left: 0,
                  bg: "blue.200",
                  zIndex: -1,
                }}
              >
                Whatsapp Chat
              </Text>
              <br />
              <Text as={"span"} color={"blue.400"} fontSize={"5xl"}>
                to calendar events!
              </Text>
            </Heading>
            <Text color={"gray.500"}>
              Convert WhatsApp events to calendar with privacy. No data is saved
              or sent to servers. Easy and secure solution.
            </Text>
            <Stack
              spacing={{ base: 4, sm: 6 }}
              direction={{ base: "column", sm: "row" }}
            >
              <Button
                as={LinkOverlay}
                href={"/tool"}
                size={"lg"}
                rightIcon={<ArrowForwardIcon />}
                px={6}
                colorScheme={"blue"}
                className={"rightIconAnimate"}
              >
                Get started
              </Button>
              <Button
                as={LinkOverlay}
                onClick={onOpen}
                size={"lg"}
                px={6}
                className={"buttonClick"}
                leftIcon={<PlayIcon h={4} w={4} color={"gray.400"} />}
              >
                How It Works
              </Button>
            </Stack>
          </Stack>
          <Flex
            flex={1}
            justify={"center"}
            align={"center"}
            position={"relative"}
            w={"full"}
          >
            <Blob
              w={"150%"}
              h={"150%"}
              position={"absolute"}
              top={"-20%"}
              left={0}
              zIndex={-1}
              color={useColorModeValue("blue.50", "blue.400")}
            />
            <Box
              position={"relative"}
              height={["auto", "auto", "auto", "auto", "390px"]}
              rounded={"md"}
              boxShadow={"2xl"}
              width={"full"}
              overflow={"hidden"}
              className={"buttonClick"}
              as={LinkOverlay}
              onClick={onOpen}
            >
              <IconButton
                aria-label={"Play Button"}
                variant={"ghost"}
                _hover={{ bg: "transparent" }}
                icon={<PlayIcon w={12} h={12} />}
                size={"lg"}
                color={"gray"}
                position={"absolute"}
                left={"50%"}
                top={"50%"}
                transform={"translateX(-50%) translateY(-50%)"}
              />
              <Image
                alt={"Hero Image"}
                fit={"cover"}
                align={"center"}
                w={"100%"}
                h={"100%"}
                src={videoThumbnailUrl}
              />
            </Box>
          </Flex>
        </Stack>
        <Modal
          isCentered
          isOpen={isOpen}
          onClose={onClose}
          m={{ base: 3, sm: 3, md: 3 }}
          size={{ base: "sm", md: "xl", lg: "3xl" }}
        >
          <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(1px)" />
          <ModalContent>
            <ModalBody p={0} alignContent={"center"}>
              <AspectRatio maxW={"100%"} ratio={16 / 9}>
                <iframe
                  width="1519"
                  height="656"
                  src="https://www.youtube.com/embed/SlgNCIRjUUs"
                  title="How to use WpCalendar -Whatsapp Chat to calendar events tool"
                  frameborder="0"
                  style={{ borderRadius: "5px" }}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </AspectRatio>
            </ModalBody>
          </ModalContent>
        </Modal>
        {/* Headings and features content for home page */}
        <VStack maxW={"7xl"} margin={"0 auto"}>
          <Heading as="h4" textAlign={"center"}>
            Welcome to WpCalendar
          </Heading>
          <Text fontSize="h3" textAlign={"center"}>
            Effortlessly Convert WhatsApp Chat Events to Calendar Events with
            Our Privacy-Conscious Tool
          </Text>
          <SimpleGrid
            width={"100%"}
            columns={{ base: 1, md: 3 }}
            className={"feature"}
            spacing={10}
          >
            <Feature
              imageUrl={chatImageUrl}
              title={"Whatsapp Chat"}
              text={
                "Our tool makes it easy to keep track of important events in your WhatsApp chats, such as birthdays and anniversaries. Simply upload a chat export from WhatsApp and our tool will automatically identify and make ics file for your calendar to add these events to notify the event on special day to wish."
              }
              altDesc={"Whatsapp Chat illustration"}
            />
            <Feature
              imageUrl={privacyImageUrl}
              title={"Privacy oriented"}
              text={
                "Best of all, our tool respects your privacy and does not send any of your chat data to our servers or save it anywhere. All processing is done locally in your web browser, so you can be confident that your personal chats remain private."
              }
              altDesc={"Privacy Oriented illustration"}
            />
            <Feature
              imageUrl={calendarImageUrl}
              title={"Easy life"}
              text={
                <Fragment>
                  Instead of relying on your memory or trying to manually write
                  down all the events, you can now have them all in one
                  convenient place. <br />
                  <b>
                    Give it a try and never miss another important event in your
                    WhatsApp chats again!
                  </b>
                </Fragment>
              }
              altDesc={"Calendar with events illustartion"}
            />
          </SimpleGrid>
          <Text mt={2}>Made by Soham_UltraHopeful with ❤️</Text>
        </VStack>
      </SimpleGrid>
    </div>
  );
};

export default Home;
